/* ──────────────────────────────────────────────────────────────
 *  OODWarningDialog — Out-of-Distribution warning
 *
 *  Shown after compute when packaging values fall outside the
 *  training distribution. Simple alert with an OK button.
 *
 *  Ported from BushingApp.ood_dialog (optibush.py).
 * ────────────────────────────────────────────────────────────── */

import React from 'react';
import Button from '@mui/material/Button';
import WarningIcon from '@mui/icons-material/Warning';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';

const OODWarningDialog: React.FC = () => {
  const open = useUIStore((s) => s.oodDialogOpen);
  const closeDialog = useUIStore((s) => s.closeDialog);

  const handleClose = () => closeDialog('oodDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title="Out of Distribution Warning"
      titleColor="error.main"
      icon={<WarningIcon color="error" sx={{ fontSize: 28 }} />}
      maxWidth={500}
      actions={
        <Button variant="contained" color="primary" onClick={handleClose}>
          OK
        </Button>
      }
    >
      Packaging values are out of distribution (OOD). Results might not correlate
      exactly with FEA.
    </DialogShell>
  );
};

export default OODWarningDialog;
